/**
 * i18n Configuration
 * Supports English (en) and Hindi (hi) languages only
 */
import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationENG from "locales/en.json";
import translationHI from "locales/hi.json";

// Supported translations: English and Hindi only
const resources = {
  en: {
    translation: translationENG,
  },
  hi: {
    translation: translationHI,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en");
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
